import { apiClient } from '@/lib/api-client'
import { currentLocale } from '@/lib/i18n'
import { saveResponseAsFile } from '@/lib/download'

/**
 * Download the terms of one or more documents as a single spreadsheet.
 *
 * Used from the actions menu in both its forms: the open document's header
 * (one id) and the bulk-selection bar (many). One code path, one endpoint.
 */
export async function exportDocumentTerms(documentIds: number[]): Promise<void> {
  const res = await apiClient.post<Blob>(
    '/documents/terms.xlsx',
    { document_ids: documentIds, lang: currentLocale() },
    { responseType: 'blob' },
  )
  saveResponseAsFile(res, 'terms.xlsx')
}
